export default __webpack_public_path__ + "static/media/director.a5a7634a.png";